/**
 * Downloads a QR code as a PNG image
 * @param svgRef - The ref object containing the SVG element
 * @param filename - The name for the downloaded file (without extension)
 */
export const downloadQRCode = (
  svgRef: React.RefObject<SVGSVGElement>,
  filename = 'qr-code'
): void => {
  const svg = svgRef.current;
  if (!svg) return;

  const svgData = new XMLSerializer().serializeToString(svg);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();

  img.onload = () => {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx?.drawImage(img, 0, 0);
    const pngFile = canvas.toDataURL('image/png');

    const downloadLink = document.createElement('a');
    downloadLink.download = `${filename}.png`;
    downloadLink.href = pngFile;
    downloadLink.click();
  };

  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};
